<template>
  <div class="uncheck-wrap h-panel-body padding font-bold">
    <!-- 空数据提示 -->
    <h3 class="empty-tip" v-if="!Object.keys(dataList).length">
      暂无已完成结账的期间，无法执行反结账
    </h3>

    <!-- 年份分组 修复后 -->
    <template v-for="year in years">
      <h2 class="year-title" :key="year">{{ year }} 年</h2>
      <Row :space="20" class="month-row">
        <Cell
            v-for="month in dataList[year]"
            :key="year + month.checkMonth"
            width="3"
        >
          <div
              class="period-card"
              :class="{ disable: month.disable }"
              @click="unCheck(month)"
          >
            <div class="card-header bg-primary-color"></div>
            <div class="month-text">{{ month.checkMonth }}月</div>
          </div>
        </Cell>
      </Row>
    </template>
  </div>
</template>

<script>
export default {
  name: "UnCheckOut",
  data() {
    return {
      dataList: {}
    };
  },
  computed: {
    years() {
      // 年份倒序展示
      return Object.keys(this.dataList).sort((a, b) => b - a);
    }
  },
  methods: {
    loadList() {
      this.$api.checkout.list().then(({ data }) => {
        const checkData = {};
        data.forEach((val) => {
          // 只过滤已结账状态2的数据
          if (val.status === 2) {
            if (!checkData[val.checkYear]) {
              checkData[val.checkYear] = [];
            }
            checkData[val.checkYear].push(val);
          }
        });
        this.dataList = checkData;
      });
    },
    unCheck(data) {
      this.$Confirm("确定执行反结账操作？", "反结账提醒")
          .then(() => {
            this.$Loading("正在撤销结账数据...");
            this.$api.checkout.unCheck({
              year: data.checkYear,
              month: data.checkMonth
            })
                .then(() => {
                  this.$Message.success("反结账成功");
                  this.loadList();
                })
                .finally(() => {
                  this.$Loading.close();
                });
          });
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>

<style lang="less" scoped>
.uncheck-wrap {
  // 空提示
  .empty-tip {
    text-align: center;
    padding: 60px 0;
    font-size: 15px;
    color: #999;
    font-weight: normal;
    margin: 0;
  }

  // 年份标题
  .year-title {
    font-size: 20px;
    color: #262626;
    margin: 0 0 14px 0;
    padding-left: 6px;
    border-left: 4px solid @primary-color;
    line-height: 1;
  }

  .month-row {
    margin-bottom: 24px;
  }

  // 月份卡片主体
  .period-card {
    border-radius: 8px;
    border: 1px solid @gray1-color;
    height: 86px;
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    transition: all 0.24s ease;

    // 顶部标题栏
    .card-header {
      height: 26px;
      width: 100%;
    }

    // 月份文字
    .month-text {
      height: calc(100% - 26px);
      line-height: 60px;
      text-align: center;
      font-size: 20px;
      color: #333;
      font-weight: 500;
    }

    // 可点击hover上浮效果
    &:hover:not(.disable) {
      cursor: pointer;
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(120, 120, 120, 0.16);
    }

    // 禁用状态
    &.disable {
      opacity: 0.4;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }
}
</style>